module.exports = __webpack_public_path__ + "static/img/Hawthorn.ae3c8be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hawthorn.jpg
// module id = zuNq
// module chunks = 1